import type {
  FieldErrors,
  UseFormRegister,
  UseFormWatch,
} from "react-hook-form";
import { ConsentFormValues } from "../../lib/consent-schema";
import type { User } from "../../lib/types";
import {
  DataProtectionSection,
  CodeOfConductSection,
  PersonalDetailsSection,
  MedicalSection,
  PhotoConsentSection,
  MarketingConsentSection,
} from "../forms/SharedConsentFields";

interface ConsentFormFieldsProps {
  register: UseFormRegister<ConsentFormValues>;
  errors: FieldErrors<ConsentFormValues>;
  watch: UseFormWatch<ConsentFormValues>;
  name: string;
  user?: User | null;
}

export function ConsentFormFields({
  register,
  errors,
  watch,
  name,
  user,
}: ConsentFormFieldsProps) {
  return (
    <div className="space-y-8">
      <DataProtectionSection
        register={register}
        errors={errors}
        name={name}
        consentValue={user?.dataProcessingConsent}
        consentedAt={user?.dataProcessingConsentedAt}
      />
      <CodeOfConductSection
        register={register}
        errors={errors}
        name={name}
        consentValue={user?.consentFormCodeOfConductAccepted}
        consentedAt={user?.codeOfConductConsentedAt}
      />
      <PersonalDetailsSection
        register={register}
        errors={errors}
        watch={watch}
        name={name}
      />
      <MedicalSection
        register={register}
        errors={errors}
        watch={watch}
        name={name}
        consentValue={user?.emergencyTreatmentConsent}
        consentedAt={user?.emergencyTreatmentConsentedAt}
      />
      <PhotoConsentSection
        register={register}
        errors={errors}
        name={name}
        consentValue={user?.photoConsent}
        consentedAt={user?.photoConsentedAt}
      />
      <MarketingConsentSection
        register={register}
        name={name}
        consentValue={user?.marketingConsent}
        consentedAt={user?.marketingConsentedAt}
      />
    </div>
  );
}







